import { render, staticRenderFns } from "./PayButton.vue?vue&type=template&id=5668a9b9"
import script from "./PayButton.vue?vue&type=script&lang=ts"
export * from "./PayButton.vue?vue&type=script&lang=ts"
import style0 from "./PayButton.vue?vue&type=style&index=0&id=5668a9b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports